import React, { PropTypes } from 'react'
import { Link } from 'react-router'
import { Button } from '../buttons'
import isArray from 'lodash/isArray'

export const Details = ({
  title, actionType, actionLink, leaveRoomForControls,
  children, className,
  secondaryActionType, secondaryActionCall
}) => {
  let titleElement = null
  let action = (!!actionType && !!actionLink)
  let secondaryAction = (!!secondaryActionType && !!secondaryActionCall)
  let actionElement = null
  let secondaryActionElement = null

  if (title) {
    let styles = (action) ? { margin: '0 0 6px 72px' } : { margin: '0 0 6px 16px' }
    titleElement = <h2 style={styles} className='details-container-title'>{title}</h2>
  }

  if (action) {
    actionElement = <Link to={actionLink} className={`action-button ${actionType}`} />
  }

  if (secondaryAction) {
    if (isArray(secondaryActionType)) {
      secondaryActionElement = (
        <div>
          {secondaryActionType.map((type, idx) => <Button key={idx} onClick={secondaryActionCall[idx]} className={`action-button ${type}`} />)}
        </div>
        )
    }
    else {
      secondaryActionElement = <Button onClick={secondaryActionCall} className={`action-button ${secondaryActionType}`} />
    }
  }

  return (
    <div className={className}>
      {titleElement}
      <section className='details-container'>
        <div className="action-container">
          {actionElement}
          {secondaryActionElement}
        </div>
        <section className={`details ${leaveRoomForControls ? 'with-control-space' : ''}`}>
          {children}
        </section>
      </section>
    </div>
  )
}

Details.propTypes = {
  title: PropTypes.string,
  actionType: PropTypes.string,
  actionLink: PropTypes.string
}

export const Row = ({children}) => (
  <div className='details-row'>
    {children}
  </div>
)

export const Block = ({size, title, children, style, to}) => {
  const styles = {
    WebkitFlexGrow: size,
    flexGrow: size,
    ...style
  }

  return (
    <div style={styles} className='details-block'>
      {
        to ? <Link to={to} className="edit"><h3 className='title'>{title}</h3></Link> : <h3 className='title'>{title}</h3>
      }
      {children}
    </div>
  )
}

Block.propTypes = {
  size: PropTypes.number,
  title: PropTypes.node,
  style: PropTypes.object,
}

Block.defaultProps = {
  size: 1,
  style: {}
}



// WEBPACK FOOTER //
// ./src/components/details/details.js